import React from 'react';
import { ComponentProps } from '../..';
import Initial from './Variants/Initial';

const Small: React.FC<Omit<ComponentProps, 'size'>> = props => (
  <Initial {...props} />
);

export default Small;
